import nxModule from 'nxModule';
import templateUrl from "./deposit-product-information.template.html";

nxModule.component('depositProductInformation', {
  templateUrl,
  bindings: {
    accountDetails: "<"
  }
});
